import styles from './MainHeader.module.css'
import logoWhite from '../../../../images/Riksbyggen_logo_vit.png'
import { SignOutButton } from '../../../Buttons/ProjectEconomyHeaderButtons/SignOutButton'
import SettingsButton from '../../../Buttons/ProjectEconomyHeaderButtons/SettingsButton'
import ElementAccess from '../../../../AccessControl/ElementAccess'
import { RefreshCacheButton } from './RefreshCacheButton'
import { useProjektprognosEditingContext } from '../../context/ProjektprognosEditingContext'
import StatusBadge from '../../StatusBadge'

const MainHeader = () => {
  const { selectedPeriodReport } = useProjektprognosEditingContext()

  return (
    <header className={styles.mainBanner} data-testid="MainHeader">
      <div className={styles.logoTitle}>
        <img height="38" src={logoWhite} alt="" />
        <h1 className={styles.mainHeader}>Prognosuppföljning</h1>
      </div>
      {selectedPeriodReport && (
        <div className={`${styles.headerPeriodReport} ${styles.centerSection}`}>
          <h1 className={styles.mainHeader}>
            {`${selectedPeriodReport?.year} - ${selectedPeriodReport?.reportPeriod}` ||
              ''}
          </h1>
          <StatusBadge status={selectedPeriodReport?.status || ''} />
        </div>
      )}

      <div className={styles.buttonContainer}>
        <RefreshCacheButton />

        <>
          <ElementAccess
            scopeKey={[
              'account_templates',
              'scheduling_crud',
              'accounting_read',
              'system_settings',
            ]}
          >
            <SettingsButton />
          </ElementAccess>

          <SignOutButton />
        </>
      </div>
    </header>
  )
}

export default MainHeader
